import React from 'react';
import dayjs from "dayjs";
import Images from './Images';

const Footer = ({ page }) => {
	return (
		<div className='Page__footer'>
			<div className='PageFooter'>
				<div className='PageFooter__layout'>
					<div className='PageFooter__logo'>
						<img src={Images.report.logo5d} alt='5 Dysfunctions of a Team' />
					</div>

					<div className='PageFooter__textContainer'>
						<p className='PageFooter__paragraph'>www.tablegroup.com</p>
						<p className='PageFooter__paragraph'> &copy; Copyright {dayjs().format("YYYY")} The Table Group, Inc. </p>
					</div>

					<div className='PageFooter__pageContainer'>
						<p className='PageFooter__page'>
							{page}
							<span className='PageFooter__pageTriangle'>
								<img src={Images.report.pageTriangle} alt='' />
							</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
